import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

/** Returns true when the current URL carries an MSAL auth response (`code` or `error` param). */
function hasAuthResponse(): boolean {
    const hash = new URLSearchParams(window.location.hash.slice(1));
    const query = new URLSearchParams(window.location.search);
    return hash.has('code') || hash.has('error') || query.has('code') || query.has('error');
}

/**
 * MSAL 5.x redirect bridge handler. Call this before rendering the app.
 *
 * Returns true if an auth redirect was detected and handled:
 * - Popup: broadcasts result via BroadcastChannel, then window.close() fires.
 * - Top-level redirect fallback: stores payload in sessionStorage and navigates
 *   back to the origin URL; the app will render fresh there via handleRedirectPromise.
 *
 * Returns false when there is no auth response in the URL (normal app load).
 */
export async function handleAuthRedirect(): Promise<boolean> {
    if (!hasAuthResponse()) return false;
    await broadcastResponseToMainFrame();
    return true;
}
